<template lang="pug">
.temporaryArticles
  SectionTitle(
    sectionText="使用者回報訊息"
  )

  ul.temporaryArticles-list
    li.temporaryArticles-item(v-for="article in displayArticles")
      p.temporaryArticles-paragraph {{article.content}}
      .temporaryArticles-bottom
        .temporaryArticles-createdAt
          span 回報時間：
          span {{formatedDate(article.createdAt)}}
          a.temporaryArticles-createdAt(v-if="article.type === 'image' " :href="article.thumbnailUrl" target="_blank")
            span  |
            img.temporaryArticles-typeIcon(src="https://vos.line-scdn.net/factchecker/img/type-image-icon.png")
            span 圖片資訊內容
          a.temporaryArticles-createdAt(v-if="article.type === 'audio' " :href="article.sourceMedia" target="_blank")
            span  |
            img.temporaryArticles-typeIcon(src="https://vos.line-scdn.net/factchecker/img/type-audio-icon.png")
            span 語音資訊內容
        .temporaryArticles-icon(v-if="article.isChild")
          i.icon-flag
        .temporaryArticles-buttons(v-else)
          a.temporaryArticles-buttonEdit(@click='isMigrating(article.id)')
            i.icon-button-relocate.show--mobileOnly
            span.temporaryArticles-buttonText.hide--mobile 連動其他結果
          a.temporaryArticles-buttonRelocate(@click='isRelating(article.id)')
            i.icon-button-copy.show--mobileOnly
            span.temporaryArticles-buttonText.hide--mobile 複製本篇結果

  .temporaryArticles-footer
    Pagination(:pageCount='totalPages' @changePage='changePage')

  PopupMigrateVerifiedArticles(
    v-if="isToRelateToCurrent"
    @closePopup="stop"
    @send='sendToVerify($event)'
    :currentArticleId="currentArticleId"
    isInputArticleId=false
    text="確定要複製本篇查核結果嗎?"
  )

  PopupMigrateVerifiedArticles(
    v-if="isToRelateToOther"
    @closePopup="stop"
    @send='sendToVerify($event)'
    isInputArticleId=true
    text="連動至編號"
  )

  PopupContentIconText(
    v-if='isActionFailed===true'
    @closePopup="closePopup" :popupSimpleText="popupSimpleText" :iconType="iconType"
  )

</template>

<script>
import dataformat from 'dateformat';
import Pagination from '@/components/modules/pagination/pagination.vue';
import SectionTitle from '@/components/modules/section_title/section_title.vue';
import PopupMigrateVerifiedArticles from '@/components/popup/popup_migrate_verified_articles.vue';
import PopupContentIconText from '@/components/popup/popup_content_icon_text.vue';
import { relateToArticle } from '@/utils/api';
const ITEMS_PER_PAGE = 10;

export default {
  components: {
    Pagination,
    SectionTitle,
    PopupMigrateVerifiedArticles,
    PopupContentIconText
  },
  props: {
    currentArticleId: String,
    articles: Array,
    info: Object
  },
  computed: {
    totalPages() {
      const len = this.articles && this.articles.length;
      return len ? Math.ceil(len / ITEMS_PER_PAGE) : 1;
    },
    apiToken() {
      return localStorage.getItem(this.$store.state.storageKeys.token);
    },
  },
  data: function() {
    return {
      selectedArticleId: null,
      displayArticles: [],
      isToRelateToOther: false,
      isToRelateToCurrent: false,
      isActionFailed: false,
      popupContentIconText: false,
      iconType: '',
      popupSimpleText: '',
      currentPage: 1,
    };
  },
  created() {
    this.changePage();
  },
  watch: {
    articles() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
      this.changePage(this.currentPage);
    }
  },
  methods: {
    formatedDate(datetime) {
      if (!datetime) return '';
      const d = new Date(datetime);
      return dataformat(d, 'yyyy/mm/dd HH:MM');
    },
    changePage(page = 1) {
      this.currentPage = page;
      const beginPoistion = (page - 1) * ITEMS_PER_PAGE;
      const endPosition = beginPoistion + ITEMS_PER_PAGE;
      this.displayArticles = (this.articles || []).slice(
        beginPoistion,
        endPosition
      );
    },
    isMigrating(articleId) {
      this.selectedArticleId = articleId;
      this.isToRelateToOther = true;
    },
    isRelating(articleId) {
      this.selectedArticleId = articleId;
      this.isToRelateToCurrent = true;
    },
    stop() {
      this.isToRelateToOther = false;
      this.isToRelateToCurrent = false;
      this.selectedArticleId = null;
    },
    sendToVerify(targetArticleId) {
      relateToArticle(this.apiToken, this.selectedArticleId, targetArticleId)
        .then(() => this.$emit('onRefresh'))
        .catch(() => {
          this.isActionFailed = true;
          this.popupContentIconText = true;
          this.iconType = 'error';
          this.popupSimpleText = '發生錯誤';
        });
    },
    closePopup() {
      this.popupContentIconText = false;
      this.isActionFailed = false;
    }
  }
};
</script>

<style src="./TemporaryArticles.vue.css"></style>
